import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container'
import { format } from '../../../../../common/services/common.service'

export default function BusinessUserInfoComponent ({tenantsDetails}: any) {

  return (
    <>
      <AccordionContainer
        child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <div>
                    <InputLabelContainer
          label="FirstName"
      />
  <InputLabelContainer
      label={tenantsDetails?.BusinessUser?.FirstName}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="LastName"
      />
  <InputLabelContainer
      label={tenantsDetails?.BusinessUser?.LastName}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Email"
      />
  <InputLabelContainer
      label={tenantsDetails?.BusinessUser?.Email}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="PhoneNumber"
      />
  <InputLabelContainer
      label={tenantsDetails?.BusinessUser?.PhoneNumber}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="CreatedOnUtc"
      />
  <InputLabelContainer
      label={format(tenantsDetails?.BusinessUser?.CreatedOnUtc)}
  />
                    </div>
                    <div>
                    <InputLabelContainer
          label="ModifiedOnUtc"
      />
  <InputLabelContainer
      label={format(tenantsDetails?.BusinessUser?.ModifiedOnUtc)}
  />
                    </div>
        </div>
      }
        expandedPanel="Email"
        headerTitle="Email"
      />


    </>
  )
}